import clsx from 'clsx';
import React from 'react';

import IconCheckMark from '@components/Images/Rebranding/IconCheckMark';
import { ANNUAL_BENEFITS, PRO_BENEFITS } from '@components/pages/DualSubscribe/constants';

const annualizedBenefits = ANNUAL_BENEFITS.map((benefit) => benefit.label).filter(Boolean);
const proBenefits = PRO_BENEFITS.map((benefit) => benefit.label).filter(Boolean);

interface StaticBenefitsProps {
  className?: string;
  isPro?: boolean;
}

const StaticBenefits = ({ className, isPro = false }: StaticBenefitsProps) => {
  const BENEFITS = [...annualizedBenefits, ...(isPro ? proBenefits : [])];

  return (
    <ul className={clsx(className, 'm-0 mb-32 list-none p-0 md:mb-0')}>
      {BENEFITS.map((benefit, index) => (
        <li
          key={index}
          className="mb-16 flex items-center font-suisse-screen text-disclosure-lg text-grayscale-gray last:mb-0"
        >
          <IconCheckMark
            className={clsx('mr-16 h-10 shrink-0', {
              'text-primary-magenta': !isPro,
              'text-pro-gold': isPro,
            })}
          />
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
  );
};

export default StaticBenefits;
